export const pinFormatter = (pin: string | null | undefined): string => {
    if (!pin) return '-';
    if (pin.length != 6) return pin;
    return `${pin[0]}${pin[1]}${pin[2]} ${pin[3]}${pin[4]}${pin[5]}`;
};
